import React from "react"
import styled from "styled-components"
import colors from "../../../../styles/colors"

const StyledSvg = styled.svg`
  transition: color 0.2s ease;
  &:hover {
    path {
      fill: ${colors.green};
    }
  }
`

const Search = () => {
  return (
    <StyledSvg
      id="_2-Search"
      data-name="2-Search"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="2-Search">
        <path
          id="Fill 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5031 13.8556L11.3278 10.6717C12.3575 9.55244 12.9573 8.09018 12.9573 6.45474C12.9573 2.92622 10.0404 1.86496e-07 6.52129 1.86496e-07C3.00385 -0.000852939 0 2.92537 0 6.45389C0 9.98242 2.91769 12.9086 6.43683 12.9086C8.06715 12.9086 9.52514 12.3072 10.6419 11.2723L13.8769 14.5014L14.5031 13.8556ZM0.858244 6.45389C0.858244 3.35534 3.34681 0.859097 6.43683 0.859097C9.52514 0.859097 12.0137 3.35534 12.0137 6.45389C12.0137 9.55159 9.52514 12.0487 6.43683 12.0487C3.34681 12.0487 0.858244 9.55159 0.858244 6.45389Z"
          fill="black"
        />
      </g>
    </StyledSvg>
  )
}

export default Search
